export default class ToggleGroup
{
    constructor(...toggles)
    {
        // FlumpButton[]
        this.toggles = toggles;

        for(let i = 0; i < this.toggles.length; i++)
        {
            this.toggles[i].onClicked.add(this.onToggleSelected.bind(this, this.toggles[i]));
        }

        // Select the first by default
        this.toggles[0].onClicked.dispatch();
    }

    onToggleSelected(toggle)
    {
        for(let i = 0; i < this.toggles.length; i++)
        {
            this.toggles[i].loop(this.toggles[i].keys.idle);
            this.toggles[i].input.enabled = true;
        }

        toggle.loop(toggle.keys.selected);
        toggle.inputEnabled = false;
    }
}
